import { gql } from '@apollo/client'

export const PERMISSION_FRAGMENT = gql`
  fragment Permission on DAIPermission {
    id
    name
    codename
    category
  }
`
